import { DateTime } from 'luxon'
const humanizeDuration = require('humanize-duration')

export function ageInWords (date) {
  const interval = DateTime.fromISO(date).diff(DateTime.now()).milliseconds
  const ageSuffix = interval > 0 ? 'from now' : 'ago'
  return `${humanizeDuration(DateTime.fromISO(date).diff(DateTime.now()), { largest: 2, round: true })} ${ageSuffix}`
}
